import React from 'react';

const isElement = (element: Record<string, unknown> | null | undefined) => React.isValidElement(element);

export const isDOMTypeElement = (element: Record<string, unknown> | null | undefined) =>
  isElement(element) && typeof element?.type === 'string';
